import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78c5739f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "field row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Export as:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "type", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "pdf" }, "pdf", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "image" }, "png", -1))
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "field" }
const _hoisted_10 = { class: "field" }
const _hoisted_11 = { class: "control flex-row" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "render-requirements" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = {
  key: 0,
  class: "field"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Result" }, " Result: ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectionList = _resolveComponent("SelectionList")!
  const _component_ExportRenderContainer = _resolveComponent("ExportRenderContainer")!
  const _component_PanelAttribute = _resolveComponent("PanelAttribute")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { title: "Export Multiple" }, {
    default: _withCtx(() => [
      (_ctx.pkg)
        ? (_openBlock(), _createBlock(_component_PanelAttribute, { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createTextVNode(" Will render "),
                (_ctx.viewKey)
                  ? (_openBlock(), _createElementBlock("code", _hoisted_2, _toDisplayString(_ctx.viewKey), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _withDirectives(_createElementVNode("select", {
                  class: "select is-small",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.exportStuff.target) = $event))
                }, _hoisted_8, 512), [
                  [_vModelSelect, _ctx.exportStuff.target]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_SelectionList, {
                  options: _ctx.previewArguments,
                  optionName: _ctx.optionName,
                  listName: 'Arguments',
                  onChangeSelected: _ctx.changeSelected
                }, null, 8, ["options", "optionName", "onChangeSelected"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    class: "button is-small",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.runExport())),
                    disabled: _ctx.selectedArguments.length === 0 || !_ctx.viewKey
                  }, " Render ", 8, _hoisted_12),
                  _createElementVNode("div", _hoisted_13, [
                    (_ctx.selectedArguments.length === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Select at least one argument"))
                      : _createCommentVNode("", true),
                    (_ctx.selectedArguments.length === 0 || !_ctx.viewKey)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, "+"))
                      : _createCommentVNode("", true),
                    (!_ctx.viewKey)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Select a view to render"))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              (_ctx.exporting)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_ExportRenderContainer, {
                      exporting: _ctx.exporting,
                      pkg: _ctx.pkg,
                      renderView: [_ctx.renderView],
                      previewArguments: _ctx.selectedArguments,
                      exportStuff: _ctx.exportStuff
                    }, null, 8, ["exporting", "pkg", "renderView", "previewArguments", "exportStuff"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}